import { render, staticRenderFns } from "./allocationDetail.vue?vue&type=template&id=093fbe7a"
import script from "./allocationDetail.vue?vue&type=script&lang=js"
export * from "./allocationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports